import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';

const About = () => {
  const teamMembers = [
    {
      name: 'გიორგი მაისურაძე',
      position: 'მთავარი შეფ-მზარეული',
      experience: '15 წელი',
      specialty: 'ქართული სამზარეულო',
      image: 'https://plus.unsplash.com/premium_photo-1687697861242-03e99059e833?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'გიორგი არის ქართული სამზარეულოს ექსპერტი, რომელმაც მიიღო განათლება საფრანგეთში და იტალიაში.'
    },
    {
      name: 'ნინო ბერიძე',
      position: 'სუ-შეფი',
      experience: '8 წელი',
      specialty: 'საკონდიტრო',
      image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300',
      description: 'ნინო სპეციალიზებულია საკონდიტრო ნაწარმის მომზადებაში და ქართული ტრადიციების შენარჩუნებაში.'
    },
    {
      name: 'ლევან ციციშვილი',
      position: 'სომელიე',
      experience: '12 წელი',
      specialty: 'ღვინო',
      image: 'https://images.unsplash.com/photo-1714836403365-6659229f4d53?q=80&w=707&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'ლევანი არის ღვინის ექსპერტი ჩვენს რესტორანში.'
    }
  ];

  const values = [
    {
      icon: 'fas fa-heart',
      title: 'სიყვარული',
      description: 'ჩვენ ვმზადებთ ყველა კერძს სიყვარულით და ზრუნვით'
    },
    {
      icon: 'fas fa-award',
      title: 'ხარისხი',
      description: 'ვიყენებთ მხოლოდ უმაღლესი ხარისხის ინგრედიენტებს'
    },
    {
      icon: 'fas fa-handshake',
      title: 'სანდოობა',
      description: 'ჩვენი მომხმარებლები ყოველთვის კმაყოფილები არიან'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'ინოვაცია',
      description: 'მუდმივად ვეძებთ ახალ გზებს კულინარიული გამოცდილების გასაუმჯობესებლად'
    }
  ];

  const milestones = [
    {
      year: '2010',
      title: 'რესტორანის გახსნა',
      description: 'პირველად გავხსენით ჩვენი რესტორანი თბილისის ცენტრში'
    },
    {
      year: '2015',
      title: 'პირველი ჯილდო',
      description: 'მივიღეთ "საუკეთესო ქართული რესტორანი"-ს ჯილდო'
    },
    {
      year: '2018',
      title: 'გაფართოება',
      description: 'გავაფართოვეთ რესტორანი და დავამატეთ ახალი სამზარეულო'
    },
    {
      year: '2025',
      title: '15 წლიანი იუბილე',
      description: 'ვზეიმობთ 15 წლიან ისტორიას და ვაგრძელებთ ტრადიციებს'
    }
  ];

  return (
    <div className="py-5">
      <Container>
        {/* Header */}
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-4 fw-bold text-dark mb-3">ჩვენს შესახებ</h1>
            <p className="lead text-muted">
              გაიგეთ მეტი ჩვენი რესტორანის ისტორიის, ღირებულებების და გუნდის შესახებ
            </p>
          </Col>
        </Row>

        {/* Story Section */}
        <Row className="mb-5">
          <Col lg={6} className="mb-4">
            <div className="p-4">
              <h2 className="text-warning mb-4">
                <i className="fas fa-book-open me-2"></i>
                ჩვენი ისტორია
              </h2>
              <p className="lead">
                რესტორანი "ატმოსფერო" დაარსდა 2010 წელს, როდესაც ჩვენმა ოჯახმა გადაწყვიტა 
                ქართული სამზარეულოს ტრადიციების შენარჩუნება და თანამედროვე მომხმარებლებისთვის 
                მისი წარდგენა.
              </p>
              <p>
                დღეს ჩვენ ვართ ერთ-ერთი ყველაზე პოპულარული რესტორანი თბილისში, 
                სადაც ვემსახურებით როგორც ადგილობრივ, ასევე უცხოელ მომხმარებლებს. 
                ჩვენი მიზანია ქართული სამზარეულოს ტრადიციების შენარჩუნება და 
                თანამედროვე კულინარიული ტენდენციების შერწყმა.
              </p>
            </div>
          </Col>
          <Col lg={6} className="mb-4">
            <div className="position-relative">
              <img
                src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600"
                alt="რესტორანის ინტერიერი"
                className="img-fluid rounded shadow"
                style={{ height: '400px', objectFit: 'cover', width: '100%' }}
              />
              <div className="position-absolute bottom-0 start-0 m-3">
                <Badge bg="warning" text="dark" className="fs-6 px-3 py-2">
                  <i className="fas fa-calendar me-2"></i>
                  2010 წლიდან
                </Badge>
              </div>
            </div>
          </Col>
        </Row>

        {/* Values Section */}
        <Row className="mb-5">
          <Col className="text-center mb-4">
            <h2 className="text-dark mb-4">ჩვენი ღირებულებები</h2>
          </Col>
        </Row>
        <Row>
          {values.map((value, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <div className="text-center p-4">
                <div className="mb-3">
                  <i className={`${value.icon} fa-3x text-warning`}></i>
                </div>
                <h5 className="fw-bold mb-3">{value.title}</h5>
                <p className="text-muted">{value.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Team Section */}
        <Row className="mb-5">
          <Col className="text-center mb-4">
            <h2 className="text-dark mb-4">ჩვენი გუნდი</h2>
            <p className="lead text-muted">შეხვდით ჩვენს პროფესიონალ შეფ-მზარეულებს</p>
          </Col>
        </Row>
        <Row>
          {teamMembers.map((member, index) => (
            <Col lg={4} key={index} className="mb-4">
              <Card className="h-100 shadow-sm text-center">
                <Card.Img
                  variant="top"
                  src={member.image}
                  alt={member.name}
                  style={{ height: '250px', objectFit: 'cover' }}
                />
                <Card.Body className="p-4">
                  <Card.Title className="fw-bold fs-5 mb-2">{member.name}</Card.Title>
                  <Card.Subtitle className="text-warning mb-2">{member.position}</Card.Subtitle>
                  <div className="mb-3">
                    <Badge bg="light" text="dark" className="me-2">
                      <i className="fas fa-clock me-1"></i>
                      {member.experience}
                    </Badge>
                    <Badge bg="light" text="dark">
                      <i className="fas fa-star me-1"></i>
                      {member.specialty}
                    </Badge>
                  </div>
                  <Card.Text className="text-muted">{member.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Milestones Section */}
        <Row className="mb-5">
          <Col className="text-center mb-4">
            <h2 className="text-dark mb-4">ჩვენი მიღწევები</h2>
          </Col>
        </Row>
        <Row>
          {milestones.map((milestone, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <div className="text-center p-4">
                <div className="milestone-year mb-3">
                  <span className="display-6 fw-bold text-warning">{milestone.year}</span>
                </div>
                <h5 className="fw-bold mb-3">{milestone.title}</h5>
                <p className="text-muted">{milestone.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Call to Action */}
        <Row>
          <Col className="text-center">
            <div className="bg-light p-5 rounded">
              <h3 className="text-warning mb-3">
                <i className="fas fa-utensils me-2"></i>
                რესტორანი ატმოსფერო
              </h3>
              <p className="lead mb-4">
                განიცადეთ ქართული სამზარეულოს უნიკალური გემოები და 
                ჩვენი მეგობრული მომსახურება
              </p>
                              <div className="d-flex gap-3 justify-content-center flex-wrap">
                  <a href="#menu" className="btn btn-warning btn-lg fw-bold">
                    <i className="fas fa-utensils me-2"></i>
                    ნახეთ მენიუ
                  </a>
                  <a href="#reservation" className="btn btn-outline-warning btn-lg fw-bold">
                    <i className="fas fa-calendar-check me-2"></i>
                    დაჯავშნა
                  </a>
                </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
